// Initialization ______________________________________________________________
import Vue from 'vue'
import VueRouter from 'vue-router'
// import VueParallaxJs from 'vue-parallax-js'
// import Vuetify from 'vuetify'

require('./assets/css/main.scss');
// import 'vuetify/dist/vuetify.min.css';

Vue.config.productionTip = false;
// Vue.use(VueParallaxJs)
// Vue.use(Vuetify)

// Routes ______________________________________________________________________
Vue.use(VueRouter)

const routes = [
	{ path: '/welcome', component: require('./pages/home.vue'), meta: {title: 'Welcome'} },
	{ path: '/retrospective', component: require('./pages/retrospective.vue'), meta: {title: 'Retrospective'} },
	{ path: '/timeline', component: require('./pages/timeline.vue'), meta: {title: 'Timeline'} },
	{ path: '/calendar', component: require('./pages/calendar.vue'), meta: {title: 'Travelling Exhibition'} },
	{ path: '/contact', component: require('./pages/contact.vue'), meta: {title: 'Contact'} },
	{ path: '/thanks', component: require('./pages/thanks.vue'), meta: {title: 'Thanks'} },
	// { path: "*", component: require('./pages/404.vue'), meta: {title: 'Oops'}}
	{ path: '*', redirect: './welcome' }
]

const router = new VueRouter({
	routes: routes,
	// mode: 'history',
	base: '/Lumiere/',
	scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})

router.beforeEach((to, from, next) => {
	document.title = to.meta.title
	next()
})

// Directives __________________________________________________________________
Vue.directive('skroll', {
	bind(el, binding) {
		el.$onScroll = function() {
			var rect = el.getBoundingClientRect();
            var d = Math.max(0,50 - rect.top)/100;

			var bright = Math.max(100, Math.min(120, Math.floor(20*d)))
			var blur = Math.max(0, Math.min(5, Math.floor(5*d)))
			var gray = Math.max(0, Math.min(100, Math.floor(20*d)))

			el.style = 'filter: brightness(' + bright + '%) blur(' + blur + 'px) grayscale(' + gray + '%)'
		}
		document.addEventListener('scroll', el.$onScroll)
	},

	inserted(el, binding) {
		el.$onScroll()  
	},

	unbind(el, binding) {    
		document.removeEventListener('scroll', el.$onScroll)
		delete el.$onScroll
	}  
})

Vue.directive('skromm', {
	bind(el, binding) {
		el.$onScroll = function() {
			var rect = el.getBoundingClientRect();
            var d = Math.max(0,100 - rect.top)/100;

			var opacity = Math.max(.2, Math.min(1, 1-d))
			var blur = Math.max(0, Math.min(5, Math.floor(5*d)))

			el.style = 'filter: blur(' + blur + 'px); opacity: ' + opacity;
		}
		document.addEventListener('scroll', el.$onScroll)
	},

	inserted(el, binding) {
		el.$onScroll()  
	},

	unbind(el, binding) {    
		document.removeEventListener('scroll', el.$onScroll)
		delete el.$onScroll
	}  
})


// Mounting App ________________________________________________________________
const app = new Vue({
	router
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js